import React, { useEffect, useState } from "react";
import Sidebar from "../../components/admin/Sidebar";
import Navbar from "../../components/admin/Navbar";
import Footer from "../../components/Footer";
import LogoutModal from "../../components/admin/LogoutModal";
import Meta from "../../components/Meta";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Loader from "../../components/Loader";
import { Button, Modal, FormControl, Row, Col } from "react-bootstrap";
import api from "../../services/api";
import DataTable from "react-data-table-component";

const PedidoDepScreen = () => {
  const [loading, setLoading] = useState(true);
  const [usersDep, setUsersDep] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showMotivo, setShowMotivo] = useState(false);
  const [motivo, setMotivo] = useState("");
  const [depId, setDepId] = useState("");

  const userInfoAdmin = JSON.parse(localStorage.getItem("userInfoAdmin"));

  const handlerData = (dt) => new Date(dt).toLocaleDateString("pt-BR");

  const fetchDependentes = async () => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const resp = await api.get("/api/usersDep", config);
      setUsersDep(resp.data);
      setFilteredData(resp.data);
    } catch (error) {
      toast.error("Erro ao carregar dados.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDependentes();
  }, []);

  // Filtro dinâmico
  useEffect(() => {
    const text = searchText.toLowerCase();
    const filtered = usersDep.filter((item) => {
      const nome = item.nome?.toLowerCase() || "";
      const cpf = item.cpf?.toLowerCase() || "";
      const matricula = item.matricula?.toLowerCase() || "";
      const titular = item.user_id?.nome?.toLowerCase() || "";
      return (
        nome.includes(text) ||
        cpf.includes(text) ||
        matricula.includes(text) ||
        titular.includes(text)
      );
    });
    setFilteredData(filtered);
  }, [searchText, usersDep]);

  const handleAcesso = async (id, status) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      await api.post(`/api/usersDep/${id}`, {
        operador: userInfoAdmin._id,
        status,
      }, config);

      toast.success("Status atualizado com sucesso!");
      fetchDependentes(); // Atualiza a lista após alteração
    } catch (err) {
      toast.error("Erro ao atualizar status.");
    }
  };

  const handleNegarAcesso = (id) => {
    setDepId(id);
    setShowMotivo(true);
  };

  const submitMotivoHandler = async (e) => {
    e.preventDefault();
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      await api.post(`/api/usersDep/${depId}`, {
        operador: userInfoAdmin._id,
        status: 2,
        motivo,
      }, config);

      toast.success("Acesso negado com sucesso!");
      setShowMotivo(false);
      setMotivo("");
      fetchDependentes(); // Atualiza após negar
    } catch (error) {
      toast.error("Erro ao negar acesso.");
    }
  };

  const columns = [
    {
      width: "20%",
      name: "DADOS DO TITULAR",
      cell: (row) => (
        <div className="text-center">
          {row.user_id?.nome}
          <br />
          {row.user_id?.cpf}
        </div>
      ),
    },
    { name: "Nome", selector: (row) => row.nome, sortable: true },
    { name: "MATRÍCULA", selector: (row) => row.matricula },
    { name: "CPF", selector: (row) => row.cpf },
    {
      name: "DATA SOLICITAÇÃO",
      selector: (row) => handlerData(row.createdAt),
    },
    {
      name: "LIBERAR ACESSO?",
      cell: (row) => (
        <Button
          variant="success"
          size="sm"
          onClick={() => {
            if (window.confirm(`Deseja habilitar o dependente ${row.nome}?`)) {
              handleAcesso(row._id, 1);
            }
          }}
        >
          <i className="fa fa-check"></i> Acesso
        </Button>
      ),
    },
    {
      name: "NEGAR ACESSO?",
      cell: (row) => (
        <Button
          variant="danger"
          size="sm"
          onClick={() => {
            if (window.confirm(`Deseja negar o acesso do dependente ${row.nome}?`)) {
              handleNegarAcesso(row._id);
            }
          }}
        >
          <i className="fa fa-times"></i> Negar
        </Button>
      ),
    },
  ];

  const paginationOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  return (
    <>
      <ToastContainer />
      <Meta />
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />
            {loading ? (
              <Loader />
            ) : (
              <div className="container-fluid">
                <Row className="mb-3">
                  <Col md={4}>
                    <FormControl
                      type="text"
                      placeholder="Buscar nome, CPF, matrícula ou titular"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </Col>
                </Row>

                <DataTable
                  title="Gerenciamento dos Dependentes CRC"
                  columns={columns}
                  data={filteredData}
                  pagination
                  paginationComponentOptions={paginationOptions}
                  noDataComponent="Nenhum dependente encontrado."
                />
              </div>
            )}
          </div>
          <Footer />
        </div>
      </div>
      <LogoutModal />

      {/* Modal de motivo */}
      <Modal show={showMotivo} onHide={() => setShowMotivo(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Motivo - Negação de Acesso</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={submitMotivoHandler}>
            <div className="form-group">
              <label>Descreva o motivo da negação</label>
              <textarea
                className="form-control"
                rows="4"
                value={motivo}
                onChange={(e) => setMotivo(e.target.value)}
                required
              />
            </div>
            <Button type="submit" className="btn btn-primary">
              Salvar
            </Button>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PedidoDepScreen;
